import { cn } from "@workspace/ui/lib/utils";

type InfoAlertProps = {
  children: React.ReactNode;
  className?: string;
};

export function InfoAlert({ children, className }: InfoAlertProps) {
  return (
    <div
      className={cn(
        "bg-sky-100 flex items-center justify-center px-5 py-4 rounded-xl w-full",
        className,
      )}
    >
      <p className="flex-1 font-medium leading-6 md:leading-6 text-sky-700 text-sm md:text-base">
        {children}
      </p>
    </div>
  );
}
